/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEmailTemplateRequest,
  EmailTemplateResponse,
  ProblemDetails,
  ResolveEmailTemplateRequest,
  ResolvedEmailTemplateResponse,
  UpdateEmailTemplateRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateEmailTemplateRequestFromJSON,
    CreateEmailTemplateRequestToJSON,
    EmailTemplateResponseFromJSON,
    EmailTemplateResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResolveEmailTemplateRequestFromJSON,
    ResolveEmailTemplateRequestToJSON,
    ResolvedEmailTemplateResponseFromJSON,
    ResolvedEmailTemplateResponseToJSON,
    UpdateEmailTemplateRequestFromJSON,
    UpdateEmailTemplateRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateEmailTemplateOperationRequest {
    createEmailTemplateRequest: CreateEmailTemplateRequest;
}

export interface DeleteEmailTemplateRequest {
    id: string;
}

export interface ResolveEmailTemplateOperationRequest {
    id: string;
    resolveEmailTemplateRequest: ResolveEmailTemplateRequest;
}

export interface UpdateEmailTemplateOperationRequest {
    id: string;
    updateEmailTemplateRequest: UpdateEmailTemplateRequest;
}

/**
 * EmailTemplatesApi - interface
 * 
 * @export
 * @interface EmailTemplatesApiInterface
 */
export interface EmailTemplatesApiInterface {
    /**
     * 
     * @param {CreateEmailTemplateRequest} createEmailTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApiInterface
     */
    createEmailTemplateRaw(requestParameters: CreateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailTemplateResponse>>;

    /**
     */
    createEmailTemplate(requestParameters: CreateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailTemplateResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApiInterface
     */
    deleteEmailTemplateRaw(requestParameters: DeleteEmailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteEmailTemplate(requestParameters: DeleteEmailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApiInterface
     */
    getAllEmailTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmailTemplateResponse>>>;

    /**
     */
    getAllEmailTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmailTemplateResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {ResolveEmailTemplateRequest} resolveEmailTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApiInterface
     */
    resolveEmailTemplateRaw(requestParameters: ResolveEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedEmailTemplateResponse>>;

    /**
     */
    resolveEmailTemplate(requestParameters: ResolveEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedEmailTemplateResponse>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmailTemplateRequest} updateEmailTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApiInterface
     */
    updateEmailTemplateRaw(requestParameters: UpdateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailTemplateResponse>>;

    /**
     */
    updateEmailTemplate(requestParameters: UpdateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailTemplateResponse>;

}

/**
 * 
 */
export class EmailTemplatesApi extends runtime.BaseAPI implements EmailTemplatesApiInterface {

    /**
     */
    async createEmailTemplateRaw(requestParameters: CreateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailTemplateResponse>> {
        if (requestParameters['createEmailTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createEmailTemplateRequest',
                'Required parameter "createEmailTemplateRequest" was null or undefined when calling createEmailTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/email-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmailTemplateRequestToJSON(requestParameters['createEmailTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async createEmailTemplate(requestParameters: CreateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailTemplateResponse> {
        const response = await this.createEmailTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteEmailTemplateRaw(requestParameters: DeleteEmailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteEmailTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/email-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteEmailTemplate(requestParameters: DeleteEmailTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmailTemplateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllEmailTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmailTemplateResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/email-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmailTemplateResponseFromJSON));
    }

    /**
     */
    async getAllEmailTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmailTemplateResponse>> {
        const response = await this.getAllEmailTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async resolveEmailTemplateRaw(requestParameters: ResolveEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedEmailTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveEmailTemplate().'
            );
        }

        if (requestParameters['resolveEmailTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveEmailTemplateRequest',
                'Required parameter "resolveEmailTemplateRequest" was null or undefined when calling resolveEmailTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/email-templates/{id}/resolve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveEmailTemplateRequestToJSON(requestParameters['resolveEmailTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResolvedEmailTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async resolveEmailTemplate(requestParameters: ResolveEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedEmailTemplateResponse> {
        const response = await this.resolveEmailTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateEmailTemplateRaw(requestParameters: UpdateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateEmailTemplate().'
            );
        }

        if (requestParameters['updateEmailTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateEmailTemplateRequest',
                'Required parameter "updateEmailTemplateRequest" was null or undefined when calling updateEmailTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/email-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEmailTemplateRequestToJSON(requestParameters['updateEmailTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateEmailTemplate(requestParameters: UpdateEmailTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailTemplateResponse> {
        const response = await this.updateEmailTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
